import { EducationAssignmentStatus } from '@microsoft/microsoft-graph-types';

export enum AssignmentType {
  Draft = 'draft',
  Assigned = 'assigned',
  Done = 'done',
  Scheduled = 'scheduled',
}

export enum AssignmentGroupBy {
  None = 'none',
  Day = 'day',
  CourseName = 'courseName',
}

export interface AssignmentsListItemProps {
  onClick: () => void;
  onRefresh?: () => void;
  onDone?: () => void;
  type: AssignmentType;
  assignmentName: string;
  courseName: string;
  dueDate: string;
  totalSubmissionsCount?: number;
  pendingSubmissionsCount?: number;
  returnedSubmissionsCount?: number;
  isSelected?: boolean;
  readOnly?: boolean;
  onlyClassbook?: boolean;
}

export interface AssignmentsListProps {
  items: AssignmentsListItemProps[];
  groupBy: AssignmentGroupBy;
  readonly?: boolean;
}

export interface AssignmentsBaseModel {
  classId: string;
  id: string;
  displayName: string;
  dueDateTime: string;
  status?: EducationAssignmentStatus;
}
